import { useMemo } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { useLang, isRequestedFrom } from 'utils/localisation';
import { americasRegion } from 'define/locale';
import { DEV_CENTER_ICON, DEV_CENTER_ID, HEADQUARTERS_ICON, HEADQUARTERS_ID } from 'define/offices';

export function useOfficesInfo() {
  const {
    allOffice: { nodes: offices },
  } = useStaticQuery(graphql`
    query {
      allOffice {
        nodes {
          id: officeId
          city
          country
          countryFlag
          coordinates
          address
          phone
          category {
            id
            name
            icon
          }
          images {
            url
            caption
            alt
          }
          hideOnZoomOut
          latOffset
        }
      }
    }
  `);
  const lang = useLang();

  const preparedOffices = useMemo(() => {
    if (lang === 'en' && isRequestedFrom(americasRegion)) {
      return offices.map(office => {
        if (office.city === 'Dallas') {
          return {
            ...office,
            category: {
              id: HEADQUARTERS_ID,
              name: 'Headquarters',
              icon: HEADQUARTERS_ICON,
            },
          };
        }
        if (office.city === 'Warsaw') {
          return {
            ...office,
            category: {
              id: DEV_CENTER_ID,
              name: 'Development center',
              icon: DEV_CENTER_ICON,
            },
          };
        }
        return office;
      });
    }

    return offices;
  }, [offices, lang]);

  return preparedOffices;
}
